module.exports = __webpack_public_path__ + "static/media/coverImg-Amp.08abc07c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Onboarding/coverImg-Amp.png
// module id = 33
// module chunks = 0